import { useId } from '@optimus-web/helpers';
import { VisuallyHidden } from '../helpers';
import { SegmentedControlStack } from './style';
import { SegmentedControlProps } from './types';
import { useKeyboardNavigation } from './useKeyboardNavigation';
import { useSegmentedControlItems } from './useSegmentedControlItems';

export const SegmentedControl = ({
    children,
    value,
    name,
    disabled,
    className,
    size = 'medium',
    itemWidth = 'evenly',
    onChange,
    accessibleText,
    vertical,
    ...other
}: SegmentedControlProps) => {
    const { itemRefs, childValues, currentValue, renderChildren } = useSegmentedControlItems(
        children,
        value,
        disabled,
        name,
        itemWidth,
        onChange,
        vertical,
        size
    );

    const handleKeyDown = useKeyboardNavigation(childValues, currentValue, itemRefs, disabled);

    const labelId = useId('segmented-control-label');

    return (
        <>
            {accessibleText && (
                <VisuallyHidden id={labelId} aria-hidden="true">
                    {accessibleText}
                </VisuallyHidden>
            )}
            <SegmentedControlStack
                className={className}
                size={size}
                role="radiogroup"
                radioGroup={name}
                spacing="25"
                distribution="space-between"
                onKeyDown={handleKeyDown}
                aria-labelledby={accessibleText ? labelId : undefined}
                vertical={vertical}
                {...other}
            >
                {renderChildren()}
            </SegmentedControlStack>
        </>
    );
};
